import React, { lazy, Suspense } from 'react';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';

const TopologyScene = lazy(() => import('./TopologyScene.jsx'));

/**
 * Public wrapper for the 3D Energy Flow Topology visualization.
 * Lazy-loads the Three.js scene so the bundle only downloads when used.
 * On mobile, renders FallbackComponent (or null) instead of the 3D canvas.
 */
const EnergyFlowTopology3D = ({
  solarKw,
  batteryKw,
  loadKw,
  gridKw,
  evKw,
  generatorKw,
  isDark,
  height = 400,
  FallbackComponent,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    if (FallbackComponent) {
      return (
        <FallbackComponent
          solarKw={solarKw}
          batteryKw={batteryKw}
          loadKw={loadKw}
          gridKw={gridKw}
          evKw={evKw}
          generatorKw={generatorKw}
          isDark={isDark}
          height={height}
        />
      );
    }
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height,
        overflow: 'hidden',
        borderRadius: 1,
      }}
    >
      <Suspense
        fallback={
          <Skeleton
            variant="rectangular"
            width="100%"
            height={height}
            sx={{ bgcolor: '#0a1210' }}
          />
        }
      >
        <TopologyScene
          solarKw={solarKw}
          batteryKw={batteryKw}
          loadKw={loadKw}
          gridKw={gridKw}
          evKw={evKw}
          generatorKw={generatorKw}
        />
      </Suspense>
    </Box>
  );
};

export default EnergyFlowTopology3D;
